import BaseModel from './BaseModel';
import * as AT from '../../components/container/attributes';
import QmSubject from './QmSubject';
import {$d} from '../../plugins/i18n/i18n';

const getNewestDocument = (documentList) => {
  if (!documentList || documentList.length === 0) {
    return null;
  }

  documentList = documentList.sort(
    (a, b) => new Date(b.creationDate) - new Date(a.creationDate),
  );

  return documentList[0];
};

export default class QmDocument extends BaseModel {
  constructor({
    id,
    designation = undefined,
    subject = undefined,
    creation_date = undefined,
    modification_date = undefined,
  }) {
    super(id, '', designation);
    this.designation = designation;
    this.subject = subject ? new QmSubject(subject) : undefined;
    this.creation_date = creation_date;
    this.modification_date = modification_date;
  }

  static get fkName() {
    return 'qm_subject_id';
  }

  get fkName() {
    return QmDocument.fkName;
  }

  get detailPageRoute() {
    return QmDocument.detailPageRoute;
  }

  static get detailPageRoute() {
    return 'qmDocumentDetail';
  }

  static get apiRoute() {
    return 'qm_document';
  }

  static get listPageRoute() {
    return 'QmDocumentDetail';
  }

  get apiRoute() {
    return QmDocument.apiRoute;
  }

  static get joinAttrsKey() {
    return ['subject', 'designation', 'dateCreationByDocument', 'version'];
  }

  static get listDisplayAttrs() {
    return this.getAttributes(
      ['designation', 'dateCreationByDocument', 'version'],
      ['documents'],
    );
  }

  static get detailAttrs() {
    return this.getAttributes(
      ['designation', 'documents', 'dateCreationByDocument', 'version'],
      ['documents'],
    );
  }

  static get browserDisplayAttrs() {
    return this.getAttributes([
      'designation',
      'documents',
      'dateCreationByDocument',
      'version',
    ]);
  }

  static get allAttributes() {
    return [
      this.DESIGNATION_ATTRIBUTE({}, {maxWidth: '2fr'}),
      new AT.FkQmSubjectAttribute({
        name: 'subject',
        joinPath: ['qm_subject!fk_qm_document_qm_subject_id_qm_subject'],
        fkToUpdate: 'qm_subject_id',
        tableProperties: {
          header: 'hit-app.common.qm_subject',
        },
      }),
      new AT.DateAttribute({
        name: 'creation_date',
        tableProperties: {
          header: 'hit-app.common.creation-date',
        },
      }),
      new AT.DateAttribute({
        name: 'modification_date',
        tableProperties: {
          header: 'hit-app.common.modification-date',
        },
      }),
      // Reverse relation: document.qm_document_id → qm_document (not persisted on qm_document)
      new AT.FkFileDocumentAttribute({
        name: 'documents',
        joinPath: ['fk_document_qm_document_id_qm_document'],
        readOnly: true,
      }),
      new AT.NotFetchedAttribute({
        name: 'dateCreationByDocument',
        readOnly: true,
        tableProperties: {
          header: 'hit-app.common.date',
          maxWidth: '1fr',
          readOnly: true,
        },
        transform: (data) => {
          const newestDocument = getNewestDocument(data.documents);
          if (newestDocument) {
            return $d(newestDocument.creationDate, 'long');
          }
          return '';
        },
      }),
      new AT.NotFetchedAttribute({
        name: 'version',
        readOnly: true,
        tableProperties: {
          header: 'hit-app.common.version',
          maxWidth: '0.50fr',
          readOnly: true,
        },
        transform: (data) => {
          const newestDocument = getNewestDocument(data.documents);
          if (newestDocument) {
            return newestDocument.version;
          }
          return '';
        },
      }),
    ];
  }
}
